var ModalDialogVariantEnum = {
  Standard: 'standard',
  PanelRight: 'panel-right',
  PanelLeft: 'panel-left',
  PanelBottom: 'panel-bottom',
  PanelTop: 'panel-top',
  Menu: 'menu'
};
var ModalDialogBodyWidths = ['standard', 'capped', 'grow'];
export { ModalDialogBodyWidths, ModalDialogVariantEnum };